import { LOGIN_FAILURE, LOGIN_REQUEST, LOGIN_SUCCESS, LOGOUT } from './types';

const INITIAL_STATE = {
  loggedIn: null,
  loggingIn: false,
  loggedInFail: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case LOGIN_REQUEST:
      return { ...state, loggingIn: true, loggedInFail: false };
    case LOGIN_SUCCESS:
      return {
        ...state,
        userResponse: action.payload,
        loggedIn: true,
        loggingIn: false,
      };
    case LOGIN_FAILURE:
      return {
        ...state,
        loggedIn: false,
        loggingIn: false,
        loggedInFail: true,
      };
    case LOGOUT:
      return {
        ...state,
        loggedIn: false,
        loggingIn: false,
        loggedInFail: false,
      };
    default:
      return state;
  }
};
